import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  on: PropTypes.bool,
  large: PropTypes.bool,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
};

const Loader = ({ on, large, fixed, absolute }) => {
  if(on === false) return null;
  const styles = {position: 'static'};
  if(fixed) styles.position = 'fixed';
  if(absolute) styles.position = 'absolute';

  return <div className={`loader ${large ? 'loader_large' : ''}`} style={styles}></div>;
};

Loader.propTypes = propTypes;
export default Loader;


// WEBPACK FOOTER //
// ./src/components/ui/Loader.jsx